import React, { useState, useEffect, useRef } from 'react';
import { Delete } from 'react-feather';
import { Menu } from 'react-feather';
import styles from './ListCategories.module.scss';
import { navigate } from '@reach/router';

const ListCategory = ({onHide, onClick, onDelete, pack }) => {
    // Internal props
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const ref = useRef(null);
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () =>
            document.removeEventListener('click', handleClickOutside, true);
    }, []);

    return (
        <div
            onClick={onClick}
            className={styles.writeCategoryCard}
            style={{
                backgroundColor: pack?.backgroundColor,
                color: pack?.textColor,
            }}
        >
            <div className={styles.burgerMenuWrapper}>
                <Menu
                    onClick={(e) => {
                        e.stopPropagation();
                        setDropdownVisible(!dropdownVisible)
                    }}
                    className='dropdownHolder'
                    size='24'
                />

                {dropdownVisible && (
                    <ul ref={ref} className='dropdownMenu dropdownMenuRight'>
                        <li onClick={(e) => {e.stopPropagation(); onHide()}} className='dropdownMenuItem'>{pack.hidden ? 'Restore' : 'Hide' } category</li>
                        <li
                            onClick={(e) => {
                                e.stopPropagation(); 
                                navigate(`/pack/${pack.id}`)
                            }}
                            className='dropdownMenuItem'
                        >
                            Edit category
                        </li>
                        <li
                            onClick={(e) => {e.stopPropagation(); onDelete()}}
                            className='dropdownMenuItem'
                            style={{ color: '#ff0000' }}
                        >
                            Delete category
                        </li>
                      
                    </ul>
                )}
            </div>

            <div>
                <img
                    className={styles.ImageContainer}
                    src={pack.iconUrl}
                    alt='icon-preview'
                />
            </div>
            <h2>{pack.name}</h2>
            <p>{pack.description}</p>
        </div>
    );
};

export default ListCategory;
